import React from 'react'
import PropTypes from 'prop-types'
import Select from '../../ui/Select/Select'
import TextAreaField from '../../EditCollect/BasicFields/TextAreaField'
import IssueDetailsCard from './IssueDetailsCard'
import IssuePhotoField from './IssuePhotoField'
import StatusSelect from './StatusSelect'
import { MODAL_BODY_CLASS, MODAL_FIELD_CLASS, MODAL_LABEL_CLASS } from '../shared/styles'

const TEXTAREA_CLASS = 'tw:w-full tw:rounded! tw:resize-none!'

const IssueManagementTab = ({
  issue, collectName,
  issueStatuses, statusValue, onStatusChange,
  recipientOptions, selectedUsers, onUsersChange,
  commentValue, onCommentChange,
  newPhotos, removedPhotoIds, onAddPhotos, onRemoveExisting, onRemoveNew
}) => (
  <div className={MODAL_BODY_CLASS}>
    <IssueDetailsCard
      alertName={issue.name}
      collectName={collectName}
      recipients={issue.recipients}
      resourceName={issue.answer?.resource?.name}
      resourceUrl={issue.resource_url}
      scheduledAt={issue.scheduled_at}
      triggeredAt={issue.created_at}
    />
    <div className={MODAL_FIELD_CLASS}>
      <label className={MODAL_LABEL_CLASS} htmlFor="issue-status">Statut</label>
      <StatusSelect
        inputId="issue-status"
        issueStatuses={issueStatuses}
        value={statusValue}
        onChange={onStatusChange}
      />
    </div>
    <div className={MODAL_FIELD_CLASS}>
      <label className={MODAL_LABEL_CLASS} htmlFor="issue-attribution">
        Attribution de l’alerte
      </label>
      <Select
        closeMenuOnSelect={false}
        inputId="issue-attribution"
        menuPortalTarget={document.body}
        menuPosition="fixed"
        options={recipientOptions}
        placeholder="Sélectionner des utilisateurs..."
        value={selectedUsers}
        isMulti
        onChange={onUsersChange}
      />
    </div>
    <TextAreaField
      className={MODAL_FIELD_CLASS}
      label="Commentaires"
      labelClassName={MODAL_LABEL_CLASS}
      maxLength={2000}
      name="issue-comment"
      rows={5}
      textareaClassName={TEXTAREA_CLASS}
      value={commentValue}
      onChange={onCommentChange}
    />
    <div className={MODAL_FIELD_CLASS}>
      <p className={MODAL_LABEL_CLASS}>Photos</p>
      <IssuePhotoField
        existingPhotos={issue.photos}
        newPhotos={newPhotos}
        removedPhotoIds={removedPhotoIds}
        onAddPhotos={onAddPhotos}
        onRemoveExisting={onRemoveExisting}
        onRemoveNew={onRemoveNew}
      />
    </div>
  </div>
)

IssueManagementTab.propTypes = {
  collectName: PropTypes.string,
  commentValue: PropTypes.string.isRequired,
  issue: PropTypes.shape({}).isRequired,
  issueStatuses: PropTypes.arrayOf(PropTypes.shape({
    color: PropTypes.string,
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  })),
  newPhotos: PropTypes.arrayOf(PropTypes.instanceOf(File)).isRequired,
  onAddPhotos: PropTypes.func.isRequired,
  onCommentChange: PropTypes.func.isRequired,
  onRemoveExisting: PropTypes.func.isRequired,
  onRemoveNew: PropTypes.func.isRequired,
  onStatusChange: PropTypes.func.isRequired,
  onUsersChange: PropTypes.func.isRequired,
  recipientOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  removedPhotoIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedUsers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  statusValue: PropTypes.number
}

IssueManagementTab.defaultProps = {
  collectName: '',
  issueStatuses: [],
  statusValue: null
}

export default IssueManagementTab
